import createConfiguracionTurnosForm from './createConfiguracionTurnosFormModel';
const {
  formField: {
    name,
    cargo,
    fechaInicioTurno,
    TipoTurno,
    turnos,
    autoGenerarse,
    domingosyFestivos,
    frecuencia,
  },
} = createConfiguracionTurnosForm;

export default {
  [name.name]: '',
  [cargo.name]: null,
  [fechaInicioTurno.name]: null,
  [TipoTurno.name]: null,
  [turnos.name]: [],
  [autoGenerarse.name]: false,
  [domingosyFestivos.name]: false,
  [frecuencia.name]: null,
};
